import script from "./rulePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./rulePopup.vue?vue&type=script&setup=true&lang=ts"

import "./rulePopup.vue?vue&type=style&index=0&id=7af82418&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af82418"]])

export default __exports__